import { render } from "./NamespaceRow.vue?vue&type=template&id=47fcdc09&scoped=true"
import script from "./NamespaceRow.vue?vue&type=script&lang=js"
export * from "./NamespaceRow.vue?vue&type=script&lang=js"

import "./NamespaceRow.vue?vue&type=style&index=0&id=47fcdc09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fcdc09"]])

export default __exports__